<template>
  <p>
    <label :id="`label_` + name" :for="name">{{ label }}</label>
    <textarea
      :type="type || 'text'"
      :name="name"
      :id="name"
      :required="required"
      :value="htmlDecode(value)"
      v-on:input="$emit('input', $event.target.value)"
    ></textarea>
  </p>
</template>

<script>
export default {
  props: {
    name: String,
    label: String,
    type: String,
    value: String,
    required: {
      type: [Boolean, String],
      default () {
        return false
      }
    }
  },
  methods: {
    htmlDecode (str) {
      let decodedStr = str
      const doc = new DOMParser()
      while (decodedStr !== (decodedStr = doc.parseFromString(decodedStr, 'text/html').documentElement.textContent)) {}
      return decodedStr.replace(/&amp;/g, '&').replace(/(<([^>]+)>)/gi, '')
    }
  }
}
</script>
